import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import historyIcon from "../../assets/images/history-icon.svg";
import jpgIcon from "../../assets/images/jpg-icon.png";
import pdfIcon from "../../assets/images/pdf -icon.png";
import pngIcon from "../../assets/images/png-icon.png";
import FormButton from "../../Components/Buttons/FormButton";
import Loader from "../../Components/GlobalLoader/Loader";
import DynamicDetailGrid from "../../Components/Grid/DynamicDetailGrid";
import { HistoryLayoutDataCompanyAccountDetails } from "../../Data/testData";
import HistoryLayout from "../../Layout/HistoryLaout";
import PageHeader from "../../Layout/PageHeader";
import { getFileExtension } from "../../Utility/Utility";
import { getAccountDetails } from "./service/accountOverview.services";
import useUserStore, { userAccess } from "../../store/auth/userStore";

export default function CompanyAccountDetails() {
  const pageName = "Company Account";
  const navigate = useNavigate();
  const [accountsData, setAccountsData] = useState<any>(null);
  const { id } = useParams<{ id: string }>();
  const [isShowCanvas, setShowCanvas] = useState(false);
  const [loader, setLoader] = useState(true);
  const {currentUser,fetchUser}=useUserStore();
  const [userAccess,setUserAccess] = useState<userAccess | null>(null);
  useEffect(() => {
    setLoader(true);
    loadCompanyDataById();
    fetchUser().then((user:userAccess | null)=>{
      setUserAccess(user);
    }).then(()=>{
      setLoader(false);
    })
  }, []);

  const loadCompanyDataById = async () => {
    await getAccountDetails(id)
      .then((res: any) => {
        setAccountsData(res.data);
        setLoader(false);
      })
      .catch((Error) => {
        console.log(Error);
      });
  };
  const handelEditAction = (data: any) => {
    navigate(`/account/company-account/edit/${data.id}`);
  };
  const handelCanvas = () => {
    setShowCanvas(!isShowCanvas);
  };
  const historyData = (
    <>
      <div
        className="d-flex justify-content-between w-100 align-items-center px-4"
        onClick={handelCanvas}
      >
        <div>
          <h6 className="cursor-pointer m-0 d-flex align-items-center">
            <img src={historyIcon} className="me-2" />
            History
          </h6>
        </div>
      </div>
    </>
  );

  const companyAccountDetailsData = [
    { label: "Account Title", value: accountsData && accountsData?.name },
    { label: "Account ID", value: accountsData && accountsData?.code },
    {
      label: "URL",
      value:
        accountsData &&
        accountsData.links?.map((link: any, index: number) => (
          <a href={link.url} className="nav-link text-primary">
            {link?.url}
          </a>
        )),
    },
    {
      label: "Account Type",
      value: accountsData && accountsData?.type?.description,
    },
    {
      label: "Account Source",
      value: accountsData && accountsData?.source?.description,
    },

    {
      label: "Subscription Amount",
      value: accountsData && accountsData?.subscription_amount,
    },
    {
      label: "No. of Warehouse(s)",
      value: accountsData && accountsData?.subscription_warehouses,
    },
    {
      label: "No. of Client(s)",
      value: accountsData && accountsData?.subscription_clients,
    },
    {
      label: "No. of User(s)",
      value: accountsData && accountsData?.subscription_users,
    },
    {
      label: "Attachments",
      value:
        accountsData && accountsData?.attachments.length > 0 ? (
          accountsData?.attachments?.map(
            (attachment: { original_name: string }, index: number) => (
              <div
                key={index}
                className="me-3 d-flex gap-2 d-flex align-items-center"
              >
                <img
                  src={
                    getFileExtension(attachment.original_name) === "png"
                      ? pngIcon
                      : getFileExtension(attachment.original_name) === "pdf"
                      ? pdfIcon
                      : getFileExtension(attachment.original_name) === "jpg"
                      ? jpgIcon
                      : "" // fallback for any other file types
                  }
                  alt={`${getFileExtension(attachment.original_name)} icon`}
                />
                {attachment.original_name}
              </div>
            )
          )
        ) : (
          <></>
        ),
    },
    {
      label: "Account Logo",
      value:
        accountsData && accountsData.logo ? (
          <img
            src={accountsData?.logo?.url}
            style={{ height: "100px", width: "100px" }}
          />
        ) : (
          <></>
        ),
    },
  ];

  return !loader ? (
    <>
      <PageHeader
        addUrl="/account/company-account/add"
        listUrl="/account/company-account/list-view"
        gridUrl="/account/company-account/grid-view"
        name={pageName}
        viewType={true}
        isHistoryEnabled={accountsData !== null ? true : false}
        historyData={accountsData !== null ? [historyData] : null}
      />
      <div className="clearfix"></div>
      <h5 className="text-start mt-1 mb-3">
        {pageName} ({accountsData && accountsData.code})
      </h5>
      <DynamicDetailGrid
        columns={3}
        data={companyAccountDetailsData}
        isExpandable={false}
      />
      { userAccess && userAccess?.is_spherewms_admin ? (
          <div className="my-2 bg-white rounded py-3">
          <div className="d-flex flex-row-reverse">
            <FormButton
              className="sph-btn me-4"
              handleClick={() => handelEditAction(accountsData)}
            >
              Edit
            </FormButton>
          </div>
        </div>
      ) : (
        <></>
      )}

      <HistoryLayout
        isShowCanvas={isShowCanvas}
        handelCanvas={handelCanvas}
        data={HistoryLayoutDataCompanyAccountDetails}
      />
    </>
  ) : (
    <Loader />
  );
}
